import React from 'react';
import Col from 'react-bootstrap/Col';

const SuggestedResults = ({
    editCustomer,
    keyDown,
    results,
    selectedItem
}) => {
    const searchResults = results &&
        Array.isArray(results) &&
        results.map((item, index) =>
            <div
                key={item.id}
                className={`quick-search-result ${index === selectedItem ? 'selected' : ''}`}
                onClick={() => editCustomer(item.id)}
                onKeyDown={(e) => keyDown(e, item.id)}>
                <span>{item.name}</span><div>{item.address}</div><div>{item.phone}</div>
            </div>
        );

    return (
        <Col>
            <div className="quick-search-results">
                {searchResults &&
                    (searchResults.length === 0 ?
                        (
                            <div className="text-center">
                                No Items Found
                            </div>
                        ) : (
                            <div>
                                {searchResults}
                            </div>
                        )
                    )
                }
            </div>
        </Col>
    );
}

export default SuggestedResults;